"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dismissable = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var pro_regular_svg_icons_1 = require("@fortawesome/pro-regular-svg-icons");
var Icon_1 = require("./Icon");
var Loader_1 = require("./Loader");
var colorForType = function (type) {
    switch (type) {
        case "error":
            return "red";
        case "confirmation":
            return "green";
        default:
            return "gray";
    }
};
var CONTAINER_CLASS = function (type) {
    return "rounded p-2 my-1 bg-" + colorForType(type) + "-200 relative";
};
var DISABLED_CLASS = "opacity-50 pointer-events-none";
var HEADING_CLASS = function (type) {
    return "flex border-b border-" + colorForType(type) + "-300 pb-1 mb-3";
};
var DISMISS_BUTTON_CLASS = function (type) {
    return "\"bg-" + colorForType(type) + "-100 px-2 rounded my-auto ml-auto border\"";
};
var TITLE_CLASS = "text-sm font-semibold my-auto";
var Dismissable = function (_a) {
    var loading = _a.loading, disabled = _a.disabled, children = _a.children, onDismiss = _a.onDismiss, type = _a.type, title = _a.title;
    var userInteractionDisabled = loading || disabled;
    var handleDismiss = function (e) {
        e.preventDefault();
        if (onDismiss) {
            onDismiss();
        }
    };
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: CONTAINER_CLASS(type) + " " + (userInteractionDisabled ? DISABLED_CLASS : "") }, { children: [(0, jsx_runtime_1.jsxs)("header", __assign({ className: HEADING_CLASS(type) }, { children: [(0, jsx_runtime_1.jsx)("h3", __assign({ className: TITLE_CLASS }, { children: title }), void 0), onDismiss ? ((0, jsx_runtime_1.jsx)("button", __assign({ className: DISMISS_BUTTON_CLASS(type), onClick: handleDismiss }, { children: (0, jsx_runtime_1.jsx)(Icon_1.Icon, { icon: pro_regular_svg_icons_1.faTimes, mode: "default" }, void 0) }), void 0)) : null] }), void 0), children, loading ? (0, jsx_runtime_1.jsx)(Loader_1.Loader, {}, void 0) : null] }), void 0));
};
exports.Dismissable = Dismissable;
